import * as React from 'react';

export type RadioButtonsProps = {
    label: string;
    name: string;
    options: RadioButtonConf[];
    value?: string | null;
    labelClassName?: string;
    radioClassName?: string;
    onChange: (newValue: string) => void;
};

export type RadioButtonConf = {
    labelText: string;
    disabled?: boolean;
};

const RadioButtons: React.FunctionComponent<RadioButtonsProps> = ({
    label,
    labelClassName,
    name,
    onChange,
    options,
    radioClassName,
    value,
}) => {
    const [currentValue, setCurrentValue] = React.useState(value);
    const handleChange = (newValue: string) => {
        setCurrentValue(newValue);
        onChange(newValue);
    };

    return (
        <div className="form-group">
            <label className={labelClassName}>{label}</label>

            {options.map((option, idx) => (
                <span
                    className={`radio-line ${option.disabled ? 'disabled' : ''}`}
                    key={idx}
                    style={{ paddingLeft: 20 }}
                >
                    <label>
                        <input
                            checked={option.labelText === currentValue}
                            className={radioClassName}
                            disabled={option.disabled}
                            name={name}
                            type="radio"
                            value={option.labelText}
                            onChange={event => handleChange(event.target.value)}
                        ></input>
                        <span className={option.disabled ? 'text-muted' : ''} style={{ paddingLeft: 5 }}>
                            {option.labelText}
                        </span>
                    </label>
                </span>
            ))}
        </div>
    );
};

RadioButtons.displayName = 'RadioButtons';

export default RadioButtons;
